import styled from 'styled-components'

export default styled.div`
  background-color: ${props => props.theme.button.background};
  border: 1px solid ${props => props.theme.button.border};
  border-radius: 4px;
  color: ${props => props.theme.button.color};
  font-size: 11px;
  font-weight: 900;
  height: 35px;
  line-height: 35px;
  margin-top: 10px;
  text-align: center;
  text-transform: uppercase;
  width: 99px;
  &:hover {
    color: ${props => props.theme.button.color};
    border: 1px solid ${props => props.theme.button.hover.border};
    background-color: ${props => props.theme.button.hover.background};
  }
`
